import React from 'react'; // eslint-disable-next-line react/display-name

var Thumbnail = React.forwardRef(function (_props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    id: "thumbnailView",
    className: "bg-white xl:flex border-r-2"
  }, /*#__PURE__*/React.createElement("div", {
    id: "thumbnailPanel",
    ref: ref,
    className: "w-full flex flex-col items-center"
  }));
});
export default Thumbnail;